import { render, staticRenderFns } from "./production-order-change.vue?vue&type=template&id=9b87d22c&scoped=true"
import script from "./production-order-change.ts?vue&type=script&lang=ts&external"
export * from "./production-order-change.ts?vue&type=script&lang=ts&external"
import style0 from "./production-order-change.scoped.scss?vue&type=style&index=0&id=9b87d22c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b87d22c",
  null
  
)

export default component.exports